import defaultWireTransfer from '#themes/default/default/components/wireTransfer/wireTransfer.js';

import cBillingForm from '#themes/default/web/components/billingForm/billingForm.js';

export default {
	components: {
		cBillingForm
	},
	extends: defaultWireTransfer
};
